<template>
  <el-tabs style="position: sticky;top:0;z-index: 2;background-color: #212731" v-model="activeTab">
    <el-tab-pane name="tab1">
      <span slot="label" style="margin-left: 10px;"><i class="el-icon-user"></i>&nbsp;&nbsp;{{userName}}</span>
      <el-table stripe :data="detailDrawerData.records" >
        <el-table-column prop="accountDate" label="时间" width="150">
        </el-table-column>
        <el-table-column prop="deltaPoints" label="增减" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.deltaPoints>0">+</span>
            {{scope.row.deltaPoints}}
          </template>
        </el-table-column>
        <el-table-column prop="points" label="余额" width="80">
        </el-table-column>
        <el-table-column prop="reason" label="原因"  align="right">
        </el-table-column>
        <el-table-column width="30">
        </el-table-column>
      </el-table>
    </el-tab-pane>
  </el-tabs>

</template>
<script>
import {
  mapState
} from 'vuex';
import {isAdmin, isDoc, isAgent} from '@/utils';
import {scorepoint} from '@/api';

export default {
  name: 'AdminScorePoint',
  data() {
    return {
      activeTab: 'tab1',
      userName: '',
      detailDrawerData: {
        workerName: '',
        workerId: null,
        records: [
        ]
      },
    };
  },
  components: {
  },
  computed: {
    ...mapState('common', ['userInfo']),
    isAdmin() {
      const {role} = this.userInfo;
      return isAdmin(role);
    },
    isDoc() {
      const {role} = this.userInfo;
      return isDoc(role);
    },
    isAgent() {
      const {role} = this.userInfo;
      return isAgent(role);
    },
    examTitle() {
      if (this.isDoc) {
        return '诊断报告及其他';
      }
      return '诊断报告';
    },
  },
  async mounted() {
    this.onCreated();
  },
  watch: {
    '$route'() {
      this.onCreated();
    },
  },
  methods: {
    async onCreated() {
      this.fetchMyScore();
    },
    fetchMyScore() {
      this.userName = this.userInfo.name;
      this.detailDrawerData.records = [];
      scorepoint.getHistories(this.userInfo.id).then(res => {
        if (res.code === 10000) {
          this.detailDrawerData.records = res.data;
          this.detailDrawerData.records.forEach(item => {
            var date = new Date(Date.parse(item.accountDate));
            item.accountDate = date.toLocaleString('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
          });
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/view/WorkerScorePoint/index.vue